const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;

export const toLocalCalendarDate = (value) => {
  if (!value) return null;

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return null;

  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

export const createEventDays = (eventStartDate, eventEndDate) => {
  const startDate = toLocalCalendarDate(eventStartDate);
  const endDate = toLocalCalendarDate(eventEndDate);

  if (!startDate || !endDate || endDate < startDate) return [];

  const startDay = Date.UTC(
    startDate.getFullYear(),
    startDate.getMonth(),
    startDate.getDate()
  );
  const endDay = Date.UTC(
    endDate.getFullYear(),
    endDate.getMonth(),
    endDate.getDate()
  );
  const numberOfDays =
    Math.floor((endDay - startDay) / MILLISECONDS_PER_DAY) + 1;

  return Array.from({ length: numberOfDays }, (_, index) => {
    const date = new Date(startDate);
    date.setDate(startDate.getDate() + index);

    return { key: `day${index + 1}`, date };
  });
};

export const getCalendarDateKey = (value) => {
  const date = toLocalCalendarDate(value);

  if (!date) return null;

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};
